import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import { permissionTypes } from '@/enums/permissionTypes'
import { FormContext } from './formContext'
import { usePermissionsForInstitutions } from '@/hooks/usePermissionsForInstitutions'
import { PermissionSectionContext } from './permissionSectionContext'
import context from '@/context'

const PermissionSectionProvider = ({ institutionPermission, children }) => {
  const { targetInstitutionId, isChangeItemId } = useContext(FormContext)
  const { institutionEdit, institutionReadOnly } = usePermissionsForInstitutions(targetInstitutionId, isChangeItemId)

  const permission = useMemo(() => {
    if (context.isReportApp()) return permissionTypes.enum.Edit

    if (institutionEdit & institutionPermission) {
      return permissionTypes.enum.Edit
    }
    if (institutionReadOnly & institutionPermission) {
      return permissionTypes.enum.ReadOnly
    }
    return permissionTypes.enum.None
  }, [institutionEdit, institutionPermission, institutionReadOnly])

  return (permission === permissionTypes.enum.None ? null
    : <PermissionSectionContext.Provider value={permission !== permissionTypes.enum.Edit}>
      {children}
    </PermissionSectionContext.Provider>
  )
}

PermissionSectionProvider.propTypes = {
  institutionPermission: PropTypes.number,
  children: PropTypes.node.isRequired
}

export { PermissionSectionProvider }



// WEBPACK FOOTER //
// ./src/components/changeRequests/institutionPermissionProvider.js